import mn from "moment";
import config from "@/config/index";
import { FhsAxios } from "../../services/axios";
import { mapGetters, mapActions } from "vuex";

const identificationDocumentTypes = [
  {
    value: "identity-card",
    text: "Удостоверение личности"
  },
  {
    value: "international-passport",
    text: "Загран паспорт"
  }
];

const documentTypes = [
  {
    value: 1,
    text: "Виза"
  },
  {
    value: 2,
    text: "Миграционная карта"
  }
];

export default {
  data() {
    return {
      config: config,
      visa_types: [
        {
          value: 1,
          text: "Виза"
        },
        {
          value: 2,
          text: "Миграционная карта"
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "systemStatus",
      "isUserLegal",
      "registrationDocumentTypesList"
    ]),
    nonResidentDocumentTypes() {
      return documentTypes.map(item => {
        if (item.value === this.documentType) {
          item.selected = true;
        } else {
          item.selected = false;
        }
        return item;
      });
    },
    identificationDocumentTypes() {
      return identificationDocumentTypes.map(item => {
        if (item.value === this.identificationDocumentType) {
          item.selected = true;
        } else {
          item.selected = false;
        }
        return item;
      });
    }
  },
  methods: {
    saveFile(file, type) {
      this.$toasted.show("Загрузка...");
      let url = `signup/file-upload`;
      let formData = new FormData();
      formData.append("file", file);
      formData.append("type", type);
      FhsAxios.post(url, formData).then(res => {
        this.$toasted.clear();
        this.$toasted.clear();
        if (res.data.status) {
          this.$toasted.success(`Документ загружен`);
        } else {
          this.$toasted.error(`Ну удалось сохранить, попробуйте еше раз`);
        }
      });
    },
    dateFormat(date, format = "DD-MM-YYYY") {
      try {
        let new_date = mn(date).format(format);
        if (new_date === "Invalid date") {
          return null;
        }
        return mn(date).format(format);
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    dateReFormat(date) {
      if (date === null) {
        return null;
      }
      let year = date.substring(6, 10);
      let month = date.substring(3, 5);
      let day = date.substring(0, 2);
      return `${year}-${month}-${day}`;
    },
    isKazDoc(document_type) {
      let code = this.registrationDocumentTypesList.find(
        item => item.value == document_type
      );
      // console.log(code, this.registrationDocumentTypesList);
      if (code && code.code === "02") {
        return true;
      }
      return false;
    },
    ifFilUploaded(file_name) {},
    validateIin(number) {
      if (!(number !== null && number.length == 12)) {
        return false;
      }
      let s = 0;
      let i = 0;
      let k = 0;
      let t = 0;
      for (i = 0; i < 11; i++) {
        s = s + (i + 1) * number[i];
      }
      k = s % 11;
      if (k == 10) {
        s = 0;
        for (i = 0; i < 11; i++) {
          t = (i + 3) % 11;
          if (t == 0) {
            t = 11;
          }
          s = s + t * number[i];
        }
        k = s % 11;
        if (k == 10) {
          return false;
        }
      }
      return k == number.substring(11, 12);
    },
    ...mapActions([
      "fetchCountryList",
      "fetchDocumentTypesList",
      "fetchUserIncomeSources"
    ]),
    ...mapGetters(["registrationCountryList", "", "sessionId", "userId"])
  },
  mounted() {
    this.$emit("loading-status", false);
  }
};
